export const formatRemainingSessionTime = (
  remainingSeconds: number,
  t: (key: string, values?: Record<string, any>) => string,
) => {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  let text = "";

  if (minutes > 0) {
    text += t("minute", { count: minutes });
  }

  if (seconds > 0) {
    text += `${text ? ` ${t("and")} ` : ""}${t("second", { count: seconds })}`;
  }

  return text;
};
